import * as z from "zod/v4";

export const ItemSchema = z.object({
  title: z.string(),
  variantTitle: z.string(),
  variantId: z.string(),
  productId: z.string(),
  sku: z.string().optional(),
  quantity: z.number(),
  price: z.string(),
  images: z.array(z.string()),
  currencyCode: z.string(),
  itemValue: z.string(),
  tax: z.string().optional(),
});

export type Item = z.infer<typeof ItemSchema>;
